module.exports = __webpack_public_path__ + "static/img/GI.940c0e9c.svg";